import { HEADER } from './fragments/header'
import { FOOTER } from './fragments/footer'
import { BANNER } from './fragments/banner'
import { CHAT_SETTINGS } from './fragments/chat-settings'

export const GLOBALS_QUERY = `
  query Globals($site: [String]) {
    
	  ${ HEADER }

	  ${ FOOTER }

    ${ BANNER }

    ${ CHAT_SETTINGS }

  }
`